import React, { useState, useEffect } from 'react';
import URLManager from '../funcionalidadeNavbar/URLManager';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const HistoricoMovimentacaoEstoque = () => {
  const [materiasPrimas, setMateriasPrimas] = useState([]);
  const [materiaPrimaId, setMateriaPrimaId] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [historico, setHistorico] = useState([]);
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Carregar matérias-primas da API
    const fetchMateriasPrimas = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${URLManager.getBaseURL()}/materiaPrima/listar`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
          }
        });
        if (!response.ok) throw new Error('Erro ao buscar matérias-primas');
        const data = await response.json();
        setMateriasPrimas(data);
      } catch (error) {
        setMensagem(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchMateriasPrimas();
  }, []);

  const consultarHistorico = async () => {
    if (!materiaPrimaId) {
      setMensagem('Selecione a matéria-prima.');
      setHistorico([]);
      return;
    }
    setMensagem('');
    setHistorico([]);
    setLoading(true);
    try {
      const url = `${URLManager.getBaseURL()}/estoque/historico/${materiaPrimaId}`;
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        }
      });
      const result = await response.json();
      if (response.ok) {
        setHistorico(result);
        if (result.length === 0) setMensagem('Nenhuma movimentação encontrada.');
      } else {
        setMensagem('Erro ao consultar histórico.');
      }
    } catch (error) {
      setMensagem('Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6fa' }}>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: 32, minWidth: 350, maxWidth: 700 }}>
        <h2 style={{ textAlign: 'center', marginBottom: 24, color: '#2d3a4b' }}>Histórico de Movimentação de Estoque</h2>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Matéria-prima:</label><br />
          <Autocomplete
            options={materiasPrimas}
            getOptionLabel={option => option && (option.descricao || option.nome) ? `${option.descricao || option.nome} ${option.saldoEstoque !== undefined ? `(Saldo: ${option.saldoEstoque})` : ''}` : ''}
            filterOptions={(options, state) =>
              options.filter(option =>
                (option.descricao || option.nome || '').toLowerCase().includes(state.inputValue.toLowerCase())
              )
            }
            value={materiasPrimas.find(mp => mp.id === materiaPrimaId) || null}
            onChange={(event, newValue) => {
              setMateriaPrimaId(newValue ? newValue.id : '');
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Digite para buscar..." variant="outlined" size="small" autoFocus />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            noOptionsText="Nenhuma matéria-prima encontrada"
            sx={{ width: '100%', marginTop: 1 }}
            autoHighlight
            openOnFocus
            clearOnBlur={false}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 18 }}>
          <button
            onClick={consultarHistorico}
            disabled={loading}
            style={{
              width: '100%',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '10px 0',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              marginRight: 0
            }}
          >
            {loading ? 'Consultando...' : 'Consultar Histórico'}
          </button>
        </div>
        <button
          onClick={() => navigate(-1)}
          style={{
            width: '100%',
            background: '#607d8b',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
            marginBottom: 10
          }}
        >
          Voltar
        </button>
        {mensagem && (
          <div style={{
            marginTop: 10,
            color: historico.length ? '#388e3c' : '#d32f2f',
            background: historico.length ? '#e8f5e9' : '#ffebee',
            borderRadius: 6,
            padding: 10,
            textAlign: 'center',
            fontWeight: 500
          }}>
            {mensagem}
          </div>
        )}
        {historico.length > 0 && (
          <div style={{ marginTop: 20, overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 15 }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ border: '1px solid #ccc', padding: 6 }}>Data</th>
                  <th style={{ border: '1px solid #ccc', padding: 6 }}>Tipo</th>
                  <th style={{ border: '1px solid #ccc', padding: 6 }}>Quantidade</th>
                  <th style={{ border: '1px solid #ccc', padding: 6 }}>Usuário</th>
                </tr>
              </thead>
              <tbody>
                {historico.map((mov, idx) => {
                  const tipo = (mov.tipoMov || mov.tipoMovimentacao || mov.tipo || '').toUpperCase();
                  let bgColor = '';
                  if (tipo === 'ENTRADA') bgColor = '#e8f5e9'; // verde claro
                  else if (tipo === 'REPOSICAO') bgColor = '#ffebee'; // vermelho claro
                  else if (tipo === 'SAIDA' || tipo === 'PRODUCAO_ENTRADA') bgColor = '#fff3e0'; // laranja claro
                  return (
                    <tr key={idx} style={{ background: bgColor }}>
                      <td style={{ border: '1px solid #ccc', padding: 6 }}>{mov.dataMovimentacao || '-'}</td>
                      <td style={{ border: '1px solid #ccc', padding: 6 }}>{tipo || '-'}</td>
                      <td style={{ border: '1px solid #ccc', padding: 6 }}>{mov.quantidade || '-'}</td>
                      <td style={{ border: '1px solid #ccc', padding: 6 }}>{mov.usuario || '-'}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoricoMovimentacaoEstoque;
